export default __webpack_public_path__ + "static/media/bg.b7606248.png";